import { MessageStroke16 } from '@cian/ui-kit/prev/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackChatsIconClick } from './tracking';
import { Utility } from '../../components/Utility';
import { Utility as UtilityRedesign } from '../../components/Utility/Redesign';
import { selectIsExperimentGroupNameB } from '../../selectors/experiments/myHomeRedesign';
import { IApplicationState } from '../../types/redux';

export const UtilityMessagesContainer: React.FC = () => {
  const messagesLink = useSelector<IApplicationState, string>(state => state.servicesLinks.messages);
  const messagesCount = useSelector<IApplicationState, number>(state => state.messages.count);

  // TODO: После завершения эксперимента выпилить ненужное
  const isExperimentGroupB = useSelector(selectIsExperimentGroupNameB);

  if (isExperimentGroupB) {
    return (
      <UtilityRedesign
        data-name="UtilityMessagesContainer"
        title="Сообщения"
        unread={Boolean(messagesCount)}
        onClick={trackChatsIconClick}
        icon={MessageStroke16}
        href={messagesLink}
      />
    );
  }

  return (
    <Utility
      data-name="UtilityMessagesContainer"
      title="Сообщения"
      unread={Boolean(messagesCount)}
      onClick={trackChatsIconClick}
      icon={MessageStroke16}
      href={messagesLink}
    />
  );
};
